import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getNoticeById, formatDate, convertDriveUrl } from '../services/googleSheets';
import './NoticeDetail.css';
import ShareButton from './ShareButton';

// 첨부파일을 렌더링하는 컴포넌트
const AttachmentList = ({ attachmentUrl, attachmentName }) => {
  if (!attachmentUrl) return null;
  
  const downloadUrl = convertDriveUrl(attachmentUrl);
  const fileName = attachmentName || '첨부파일';
  
  return (
    <div className="notice-attachment-simple">
      <a 
        href={downloadUrl || attachmentUrl} 
        target="_blank" 
        rel="noopener noreferrer"
        className="attachment-link-simple"
      >
        📎 {fileName}
      </a>
    </div>
  );
};

const NoticeDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const data = await getNoticeById(id);
        if (data) {
          setNotice(data);
        } else {
          setError('해당 공지사항을 찾을 수 없습니다.');
        }
      } catch (error) {
        console.error('공지사항을 불러오는데 실패했습니다:', error);
        setError('공지사항을 불러오는데 실패했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchNotice();
  }, [id]);

  // 내용의 줄바꿈을 HTML로 변환
  const formatContent = (content) => {
    if (!content) return '';
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < content.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  if (loading) {
    return (
      <div className="notice-detail-loading">
        <div className="loading-spinner"></div>
        <p>공지사항을 불러오는 중...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="notice-detail-error">
        <h2>오류가 발생했습니다</h2>
        <p>{error}</p>
        <button onClick={() => {
          navigate('/notice');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }} className="list-btn-simple">
          목록으로 돌아가기
        </button>
      </div>
    );
  }

      return (
      <div className="notice-detail-container">
        <div className="notice-header">
          <h1>📢 공지사항</h1>
          <p>스마트폰프리운동본부의 최신 소식을 확인하세요</p>
        </div>

        <article className="notice-detail-simple">
        <div className="notice-info-row">
          <span className="notice-number">{notice.id}</span>
          <h1 className="notice-title-detail">{notice['제목'] || '제목 없음'}</h1>
          <span className="notice-date-detail">{formatDate(notice['작성일'])}</span>
        </div>

        {notice['첨부파일URL'] && (
          <AttachmentList 
            attachmentUrl={notice['첨부파일URL']} 
            attachmentName={notice['첨부파일이름']}
          />
        )}

        <div className="notice-content-simple">
          {formatContent(notice['내용'])}
        </div>

        <div className="notice-footer-simple">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <button onClick={() => {
              navigate('/notice');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }} className="list-btn-simple">
              목록
            </button>
            <ShareButton title={`${notice['제목']} - 청소년 스마트폰 프리 운동`} />
          </div>
        </div>
      </article>
    </div>
  );
};

export default NoticeDetail; 